import React, { useCallback } from 'react';
import { InputNumber } from 'antd';
import { FormikValues, useField } from 'formik';
import { InputNumberProps } from 'antd/lib/input-number';
import { useFormikFormContext } from '../FormikFormContext';
import { useInputProps } from '../hooks/useInputProps';

export interface CurrencyInputProps<T extends FormikValues>
  extends Omit<InputNumberProps, 'name'> {
  name: keyof T & string;
}

const PARSE_REGEX = /€\s?/g;

/**
 * Campo per input di tipo Valuta.
 */
export function CurrencyInput<T extends FormikValues>(
  props: CurrencyInputProps<T>
) {
  const { name } = props;
  const [field, , helpers] = useField(name);
  const inputProps = useInputProps(props);

  const handleChange = useCallback(
    (value: string | number | undefined) => {
      helpers.setValue(value === '' || value == null ? undefined : value);
    },
    [helpers.setValue]
  );

  return (
    <InputNumber
      {...field}
      onChange={handleChange}
      {...props}
      formatter={value => `€ ${value}`}
      parser={value => {
        return value ? value.replace(PARSE_REGEX, '') : '';
      }}
      decimalSeparator=","
      {...inputProps}
    />
  );
}
